// API Servis Katmanı - Tüm API çağrıları için merkezi servisler
// Bu dosya API çağrılarının tekrar eden kodlarını azaltır

import { API_ENDPOINTS, apiGet, apiPost, apiPut, apiDelete, apiRequest } from '../config/api';

// ============================================
// AUTH SERVİSLERİ
// ============================================

export const authService = {
  login: async (usernameOrEmail, password) => {
    return apiPost(API_ENDPOINTS.LOGIN, { usernameOrEmail, password });
  },
};

// ============================================
// USER SERVİSLERİ
// ============================================

export const userService = {
  // Tüm kullanıcıları getir
  getUsers: async () => {
    return apiGet(API_ENDPOINTS.USERS);
  },

  // Belirli bir kullanıcıyı getir
  getUserById: async (id) => {
    return apiGet(API_ENDPOINTS.USER_BY_ID(id));
  },

  // Yeni kullanıcı oluştur
  createUser: async (userData) => {
    return apiPost(API_ENDPOINTS.USERS, userData);
  },

  // Kullanıcı güncelle
  updateUser: async (id, userData) => {
    return apiPut(API_ENDPOINTS.USER_BY_ID(id), userData);
  },

  // Kullanıcı sil
  deleteUser: async (id) => {
    return apiDelete(API_ENDPOINTS.USER_BY_ID(id));
  },

  // Şifre kontrolü
  checkPassword: async (userId, password) => {
    return apiPost(API_ENDPOINTS.CHECK_PASSWORD, { userId, password });
  },

  // Şifre değiştir
  changePassword: async (userId, currentPassword, newPassword) => {
    return apiPost(API_ENDPOINTS.CHANGE_PASSWORD(userId), {
      currentPassword,
      newPassword,
    });
  },
};

// ============================================
// ANIMAL SERVİSLERİ
// ============================================

export const animalService = {
  // Tüm hayvanları getir
  getAnimals: async () => {
    return apiGet(API_ENDPOINTS.ANIMALS);
  },

  // Belirli bir hayvanı getir
  getAnimalById: async (id) => {
    return apiGet(API_ENDPOINTS.ANIMAL_BY_ID(id));
  },

  // Yeni hayvan oluştur
  createAnimal: async (animalData) => {
    return apiPost(API_ENDPOINTS.ANIMALS, animalData);
  },

  // Hayvan güncelle
  updateAnimal: async (id, formData) => {
    // FormData için özel istek (file upload desteği)
    return fetch(API_ENDPOINTS.ANIMAL_BY_ID(id), {
      method: 'PUT',
      body: formData
    }).then(async (response) => {
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `HTTP ${response.status}: ${response.statusText}`,
        }));
        throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
      }
      return await response.json();
    }).catch((error) => {
      console.error('API Request Error:', error);
      throw error;
    });
  },
  
  createAnimal: async (formData) => {
    // FormData için özel istek (file upload desteği)
    return fetch(API_ENDPOINTS.ANIMALS, {
      method: 'POST',
      body: formData
    }).then(async (response) => {
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `HTTP ${response.status}: ${response.statusText}`,
        }));
        throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
      }
      return await response.json();
    }).catch((error) => {
      console.error('API Request Error:', error);
      throw error;
    });
  },

  // Hayvan sil
  deleteAnimal: async (id) => {
    return apiDelete(API_ENDPOINTS.ANIMAL_BY_ID(id));
  },

  // Hayvan ağırlıkları
  getAnimalWeights: async (id) => {
    return apiGet(API_ENDPOINTS.ANIMAL_WEIGHTS(id));
  },

  addAnimalWeight: async (id, weightData) => {
    return apiPost(API_ENDPOINTS.ANIMAL_WEIGHTS(id), weightData);
  },

  // Hayvan satışı
  sellAnimal: async (id, saleData) => {
    return apiPost(API_ENDPOINTS.ANIMAL_SALE(id), saleData);
  },

  getAnimalSales: async (id) => {
    return apiGet(API_ENDPOINTS.ANIMAL_SALES(id));
  },

  // Hisse satışları
  getShareSales: async (id) => {
    return apiGet(API_ENDPOINTS.ANIMAL_SHARE_SALES(id));
  },

  createShareSale: async (id, shareSaleData) => {
    return apiPost(API_ENDPOINTS.ANIMAL_SHARE_SALE(id), shareSaleData);
  },

  getAllShareSales: async () => {
    return apiGet(API_ENDPOINTS.SHARE_SALES_ALL);
  },

  // İstatistikler
  getCounts: {
    small: async () => apiGet(API_ENDPOINTS.ANIMALS_COUNT_SMALL),
    large: async () => apiGet(API_ENDPOINTS.ANIMALS_COUNT_LARGE),
    all: async () => apiGet(API_ENDPOINTS.ANIMALS_COUNT),
  },

  getTopBranch: async () => {
    return apiGet(API_ENDPOINTS.TOP_BRANCH);
  },

  getTopSalesperson: async () => {
    return apiGet(API_ENDPOINTS.TOP_SALESPERSON);
  },
};

// ============================================
// TAHSILAT SERVİSLERİ
// ============================================

export const tahsilatService = {
  getTahsilatlar: async (userId, userRole, userInstitution) => {
    const params = new URLSearchParams({
      userId: userId || '',
      userRole: userRole || '',
      userInstitution: userInstitution || '',
    });
    return apiGet(API_ENDPOINTS.TAHSILATLAR(params.toString()));
  },

  saveTahsilat: async (tahsilatData) => {
    return apiPost(API_ENDPOINTS.TAHSILAT_KAYDET, tahsilatData);
  },
};

// ============================================
// RAPOR SERVİSLERİ
// ============================================

export const reportService = {
  getUsers: async (userRole, userInstitution, userId) => {
    const params = new URLSearchParams({
      userRole: userRole || '',
      userInstitution: userInstitution || '',
      userId: userId || '',
    });
    return apiGet(API_ENDPOINTS.REPORTS_USERS(params.toString()));
  },

  getBranches: async () => {
    return apiGet(API_ENDPOINTS.REPORTS_BRANCHES);
  },

  getPersonelReport: async (filters) => {
    const params = new URLSearchParams(filters);
    return apiGet(API_ENDPOINTS.REPORTS_PERSONEL(params.toString()));
  },

  getKurumReport: async (filters) => {
    const params = new URLSearchParams(filters);
    return apiGet(API_ENDPOINTS.REPORTS_KURUM(params.toString()));
  },

  getKasaReport: async (filters) => {
    const params = new URLSearchParams(filters);
    return apiGet(API_ENDPOINTS.REPORTS_KASA(params.toString()));
  },
};

// ============================================
// GİDER SERVİSLERİ
// ============================================

export const expenseService = {
  getBranches: async () => {
    return apiGet(API_ENDPOINTS.EXPENSES_BRANCHES);
  },

  addExpense: async (formData) => {
    // FormData için özel istek (file upload desteği)
    return fetch(API_ENDPOINTS.EXPENSES_ADD, {
      method: 'POST',
      body: formData
    }).then(async (response) => {
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `HTTP ${response.status}: ${response.statusText}`,
        }));
        throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
      }
      return await response.json();
    }).catch((error) => {
      console.error('API Request Error:', error);
      throw error;
    });
  },
};

// ============================================
// KESİM SERVİSLERİ
// ============================================

export const kesimService = {
  getAnimalKesim: async (animalId) => {
    return apiGet(API_ENDPOINTS.KESIM_ANIMAL(animalId));
  },

  saveKesim: async (kesimData) => {
    return apiPost(API_ENDPOINTS.KESIM_SAVE, kesimData);
  },
};

// ============================================
// WHATSAPP SERVİSLERİ
// ============================================

export const whatsappService = {
  sendMessage: async (messageData) => {
    return apiPost(API_ENDPOINTS.WHATSAPP_SEND, messageData);
  },
};

// ============================================
// CONTENT PLANNER SERVİSLERİ
// ============================================

export const contentPlannerService = {
  getItems: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.activeOnly !== undefined) params.set('activeOnly', String(filters.activeOnly));
    if (filters.orientation) params.set('orientation', filters.orientation);
    if (filters.mediaType) params.set('mediaType', filters.mediaType);
    const url = `${API_ENDPOINTS.CONTENT_PLANNER_ITEMS}${params.toString() ? `?${params.toString()}` : ''}`;
    return apiGet(url);
  },

  createItem: async (formData) => {
    return fetch(API_ENDPOINTS.CONTENT_PLANNER_ITEMS, {
      method: 'POST',
      body: formData
    }).then(async (response) => {
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `HTTP ${response.status}: ${response.statusText}`,
        }));
        throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
      }
      return await response.json();
    });
  },

  updateItem: async (id, formData) => {
    return fetch(API_ENDPOINTS.CONTENT_PLANNER_ITEM_BY_ID(id), {
      method: 'PUT',
      body: formData
    }).then(async (response) => {
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          error: `HTTP ${response.status}: ${response.statusText}`,
        }));
        throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
      }
      return await response.json();
    });
  },

  deleteItem: async (id) => {
    return apiDelete(API_ENDPOINTS.CONTENT_PLANNER_ITEM_BY_ID(id));
  },

  reorderItems: async (items) => {
    return apiRequest(API_ENDPOINTS.CONTENT_PLANNER_REORDER, {
      method: 'PATCH',
      body: JSON.stringify({ items })
    });
  }
};

